import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { DropzoneArea } from 'mui-file-dropzone';
import '../App.css';

const baseUrl = 'https://mobile.pwtech.ro';

function FormPage() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [files, setFiles] = useState([]); // includes uploaded + audio files
  const [audioFiles, setAudioFiles] = useState([]); // [{url, file}]
  const [dropzoneKey, setDropzoneKey] = useState(0);
  const [titleError, setTitleError] = useState('');
  const [contentError, setContentError] = useState('');
  const [showSnackbar, setShowSnackbar] = useState(false);

  const [isRecording, setIsRecording] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  const userId = localStorage.getItem('userId');
  const navigate = useNavigate();

  // === Recording Handlers ===
  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/ogg' });
        const url = URL.createObjectURL(audioBlob);
        const voiceFile = new File([audioBlob], `recording-${Date.now()}.ogg`, {
          type: 'audio/ogg',
        });

        setAudioFiles((prev) => [...prev, { url, file: voiceFile }]);
        setFiles((prev) => [...prev, voiceFile]);
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      alert('Microphone access denied.');
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  const toggleRecording = () => {
    isRecording ? stopRecording() : startRecording();
  };

  const handleDeleteAudio = (indexToDelete) => {
    const fileToRemove = audioFiles[indexToDelete]?.file;
    setAudioFiles(prev => prev.filter((_, idx) => idx !== indexToDelete));
    setFiles(prev => prev.filter(file => file !== fileToRemove));
  };

  const submitForm = async () => {
    setTitleError('');
    setContentError('');
  
    let hasError = false;
    if (!title.trim()) {
      setTitleError('Enter Title');
      hasError = true;
    }
    if (!content.trim()) {
      setContentError('Enter Content');
      hasError = true;
    }
    if (hasError) return;
  
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    formData.append('userId', userId);
  
    // Separate and append files
    const normalFiles = files.filter(f => !f.name.endsWith('.webm'));
    const audioOnlyFiles = audioFiles.map(a => a.file);
  
    normalFiles.forEach(file => formData.append('files', file));
    audioOnlyFiles.forEach(audio => formData.append('audioFiles', audio));
  
    try {
      const res = await fetch(`${baseUrl}/submit-form`, {
        method: 'POST',
        body: formData,
      });
  
      if (res.ok) {
        setTitle('');
        setContent('');
        setFiles([]);
        setAudioFiles([]);
        setDropzoneKey(prev => prev + 1);
        setShowSnackbar(true);
        setTimeout(() => setShowSnackbar(false), 3000);
      } else {
        const data = await res.json();
        alert('Error: ' + data.error);
      }
    } catch (err) {
      console.error(err);
      alert('Form submission failed');
    }
  };
  

  const logout = () => {
    localStorage.removeItem('userId');
    localStorage.removeItem('codeLink');
    navigate('/login');
  };

  return (
    <div className="container">
      <h2>Submit Form</h2>

      <input
        placeholder="Title"
        value={title}
        onChange={(e) => {
          setTitleError('');
          setTitle(e.target.value);
        }}
        style={{ borderColor: titleError ? 'red' : '' }}
      />
      {titleError && <p style={{ color: 'red' }}>{titleError}</p>}

      <textarea
        placeholder="Content"
        rows={4}
        value={content}
        onChange={(e) => {
          setContentError('');
          setContent(e.target.value);
        }}
        style={{ borderColor: contentError ? 'red' : '' }}
      />
      {contentError && <p style={{ color: 'red' }}>{contentError}</p>}

      {/*<DropzoneArea
        key={dropzoneKey}
        acceptedFiles={[
          'image/*',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
        ]}
        dropzoneText="Drag & drop or click to upload files"
        onChange={(selectedFiles) => {
          if (selectedFiles.length > 10) {
            alert('You can only upload up to 10 files.');
            return;
          }

          const newNonAudioFiles = selectedFiles.filter(
            (file) => !file.name.endsWith('.webm')
          );

          setFiles([...newNonAudioFiles, ...audioFiles.map(a => a.file)]);
        }}
        showAlerts={false}
        maxFileSize={100 * 1024 * 1024}
        filesLimit={10}
        dropzoneClass="custom-dropzone"
      />*/}

      <button
        style={{
          backgroundColor: isRecording ? '#ffc107' : '#007bff',
          marginTop: '10px',
          marginRight: '10px',
          display: 'none'
        }}
        onClick={toggleRecording}
      >
        {isRecording ? 'Stop Recording' : 'Tap To Record'}
      </button>

      {/* === Audio Previews === */}
      {audioFiles.map((audio, index) => (
        <div key={index} style={{ marginTop: '10px', width: '100%', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <audio controls src={audio.url} style={{ flex: 1 }} />
          {/* <button
            onClick={() => handleDeleteAudio(index)}
            style={{
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: '20px',
              color: 'red'
            }}
            title="Delete audio"
          >
            🗑️
          </button> */}
        </div>
      ))}

      <button onClick={submitForm}>Submit</button>

      <button
        onClick={logout}
        style={{ backgroundColor: '#dc3545', marginTop: '10px' }}
      >
        Logout
      </button>

      {showSnackbar && (
        <div
          style={{
            backgroundColor: '#28a745',
            color: 'white',
            padding: '10px 20px',
            position: 'fixed',
            top: '20px',
            right: '20px',
            borderRadius: '5px',
            boxShadow: '0px 0px 5px rgba(0,0,0,0.3)',
          }}
        >
          Form submitted successfully!
        </div>
      )}
    </div>
  );
}

export default FormPage;
